import { Button } from "../components/Button";
import { ScreenShell } from "../components/ScreenShell";
import { useUiText } from "../i18n/useUiText";
import { useAppStore } from "../state/useAppStore";

export function ThemeScreen() {
  const t = useUiText();
  const session = useAppStore((state) => state.session);
  const reviewingTheme = useAppStore((state) => state.reviewingTheme);
  const showHand = useAppStore((state) => state.showHand);
  const goHome = useAppStore((state) => state.goHome);

  if (session === null) {
    return null;
  }

  const back = reviewingTheme ? showHand : goHome;
  const backLabel = reviewingTheme ? t("history.back") : t("common.home");

  return (
    <ScreenShell
      backLabel={backLabel}
      footer={
        <Button onClick={showHand} wide>
          {reviewingTheme ? t("history.back") : t("theme.continue")}
        </Button>
      }
      onBack={back}
    >
      <div className="narrow-column theme-layout">
        <article className="theme-card">
          <p className="eyebrow">{t("theme.eyebrow")}</p>
          <h1 lang={session.theme.contentLocale}>{session.theme.title}</h1>
          <p className="theme-card__scenario" lang={session.theme.contentLocale}>
            {session.theme.scenario}
          </p>
          <div className="theme-card__rule" aria-hidden="true" />
          <h2>{t("theme.icebreakers")}</h2>
          <ol className="icebreaker-list" lang={session.theme.contentLocale}>
            {session.theme.icebreakers.map((question) => (
              <li key={question}>{question}</li>
            ))}
          </ol>
        </article>
      </div>
    </ScreenShell>
  );
}
